import { useContext as useReactContext } from 'react';

/**
 * A Custom Hook that wraps around useContext, but throws an Error with the provided errorMessage, if the Context is not found.
 *
 * @function
 * @name useContext
 * @param {React.Context} context - The React Context to be consumed.
 * @param {string} errorMessage - The Error Message to be displayed if the Context is not found.
 * @returns {React.Context} The consumed React Context.
 * @throws {Error} If the provided Context is not found.
 * @example
 * import { HeroContext } from './Hero';
 *
 * function Component() {
 *   const heroContext = useContext(HeroContext, 'Component must be a child of Hero');
 *   ...
 * }
 */
export default function useContext(context, errorMessage) {
  const reactContext = useReactContext(context);

  if (!reactContext) {
    throw new Error(errorMessage);
  }

  return reactContext;
}
